{
  "title": "Pulpit",
  "greeting": "Dzień dobry, {{name}}",
  "greetingAnonymous": "Dzień dobry",
  "scope": {
    "onlyMine": "Tylko moje",
    "workspaceTrigger": "Zmień workspace",
    "teamTrigger": "Zmień zespół",
    "allWorkspaces": "Wszystkie workspace’y",
    "allTeams": "Wszystkie zespoły",
    "searchPlaceholder": "Szukaj…",
    "pickerEmpty": "Nic nie znaleziono"
  },
  "summary": {
    "mine": "{{attention}} spraw czeka na ciebie · {{shoots}} twoich zdjęć w ciągu {{days}} dni",
    "workspace": "{{attention}} spraw wymaga uwagi · {{shoots}} zdjęć w ciągu {{days}} dni",
    "organization": "{{attention}} spraw wymaga uwagi w organizacji · {{shoots}} zdjęć w ciągu {{days}} dni",
    "team": "{{attention}} spraw wymaga uwagi w tym zespole · {{shoots}} zdjęć w ciągu {{days}} dni"
  },
  "sections": {
    "nextShoots": "Najbliższe zdjęcia",
    "nextShootsHint": "Gotowość zdjęć najbliższych dzisiejszej dacie",
    "attention": "Wymaga uwagi",
    "attentionHint": "Najpilniejsze na górze; wiersze znikają, gdy sprawa jest załatwiona",
    "pulse": "Puls",
    "pulseHint": "Najbliższe {{days}} dni",
    "timeline": "Najbliższe {{days}} dni",
    "timelineHint": "Daty zdjęć tor po torze; najedź na pasek po ekipę i status",
    "workspaces": "Workspace’y",
    "workspacesHint": "Gdzie jest teraz praca i ryzyko"
  },
  "shoot": {
    "open": "Otwórz produkcję",
    "untitled": "Produkcja bez nazwy",
    "crewMeter": "Obsadzona ekipa",
    "callsheetMeter": "Callsheet",
    "callsheet_shared": "Wysłany",
    "callsheet_building": "W przygotowaniu",
    "callsheet_missing": "Nie rozpoczęty"
  },
  "status": {
    "active": "Zdjęcia trwają",
    "ready": "Gotowa",
    "resourcing": "Obsadzanie",
    "alert": "Zagrożona",
    "draft": "Brak ról",
    "complete": "Zakończona"
  },
  "when": {
    "today": "Dziś",
    "tomorrow": "Jutro",
    "inDays_one": "za {{count}} dzień",
    "inDays_few": "za {{count}} dni",
    "inDays_many": "za {{count}} dni",
    "inDays_other": "za {{count}} dnia"
  },
  "stats": {
    "shoots": "Zdjęcia",
    "shootsHint": "w ciągu najbliższych {{days}} dni",
    "rolesFilled": "Obsadzone role",
    "rolesFilledHint": "{{booked}} z {{total}} ról",
    "pencils": "Pencile do potwierdzenia",
    "pencilsHint": "rezerwacje w ciągu {{days}} dni",
    "attention": "Wymaga uwagi",
    "attentionHint": "spraw czeka na reakcję",
    "availability": "Pytania o dostępność",
    "availabilityHint": "wysłane, wciąż bez odpowiedzi"
  },
  "filters": {
    "all": "Wszystko",
    "resourcing": "Obsadzanie",
    "availability": "Dostępność",
    "callsheets": "Callsheety",
    "bookings": "Bookingi"
  },
  "attention": {
    "ariaLabel": "Sprawy wymagające uwagi",
    "empty": "Nic tu nie czeka.",
    "rolesUnfilled": {
      "title_one": "{{count}} nieobsadzona rola w {{production}}",
      "title_few": "{{count}} nieobsadzone role w {{production}}",
      "title_many": "{{count}} nieobsadzonych ról w {{production}}",
      "title_other": "{{count}} nieobsadzonej roli w {{production}}",
      "description": "Zdjęcia startują {{date}}",
      "action": "Znajdź ekipę"
    },
    "callsheetMissing": {
      "title": "Brak callsheetu dla {{production}}",
      "description_one": "{{count}} osoba w ekipie zabookowana",
      "description_few": "{{count}} osoby w ekipie zabookowane",
      "description_many": "{{count}} osób w ekipie zabookowanych",
      "description_other": "{{count}} osoby w ekipie zabookowane",
      "action": "Otwórz"
    },
    "callsheetBuilding": {
      "title": "Callsheet dla {{production}} nie został wysłany",
      "description": "Odbiorcy nie mają szczegółów wezwania",
      "action": "Otwórz"
    },
    "availability": {
      "title": "{{resource}} jeszcze nie odpowiedział(a)",
      "someone": "Ten zasób",
      "description": "Pytanie o dostępność na {{range}}",
      "due_one": "czeka {{count}} dzień",
      "due_few": "czeka {{count}} dni",
      "due_many": "czeka {{count}} dni",
      "due_other": "czeka {{count}} dnia",
      "dueToday": "wysłane dzisiaj",
      "action": "Otwórz zasób"
    },
    "pencils": {
      "title_one": "{{count}} pencil wymaga potwierdzenia",
      "title_few": "{{count}} pencile wymagają potwierdzenia",
      "title_many": "{{count}} pencili wymaga potwierdzenia",
      "title_other": "{{count}} pencila wymaga potwierdzenia",
      "description": "Rezerwacje w ciągu najbliższych {{days}} dni",
      "due": "To okno",
      "action": "Otwórz bookingi"
    }
  },
  "timeline": {
    "empty": "Brak zdjęć w tym okresie.",
    "unassigned": "Bez zespołu",
    "crew": "Obsadzona ekipa {{booked}} / {{total}}",
    "demandTitle": "Ekipa dziennie",
    "demandHint": "Ile osób potrzebuje każdy dzień z tego okresu",
    "demandEmpty": "W tym okresie nikt nie jest potrzebny.",
    "demandBookedShort": "obsadzeni",
    "demandUnfilledShort": "wolne role",
    "demandBooked_one": "{{count}} osoba obsadzona",
    "demandBooked_few": "{{count}} osoby obsadzone",
    "demandBooked_many": "{{count}} osób obsadzonych",
    "demandBooked_other": "{{count}} osoby obsadzone",
    "demandUnfilled_one": "{{count}} nieobsadzona rola",
    "demandUnfilled_few": "{{count}} nieobsadzone role",
    "demandUnfilled_many": "{{count}} nieobsadzonych ról",
    "demandUnfilled_other": "{{count}} nieobsadzonej roli",
    "legend": {
      "active": "Zdjęcia trwają",
      "ready": "Gotowa",
      "resourcing": "Obsadzanie",
      "alert": "Zagrożona"
    }
  },
  "workspaces": {
    "shoots_one": "{{count}} zdjęcie w ciągu {{days}} dni",
    "shoots_few": "{{count}} zdjęcia w ciągu {{days}} dni",
    "shoots_many": "{{count}} zdjęć w ciągu {{days}} dni",
    "shoots_other": "{{count}} zdjęcia w ciągu {{days}} dni",
    "rolesFilled": "obsadzonych ról",
    "attention": "{{value}} do ogarnięcia",
    "noAttention": "Pod kontrolą",
    "open": "Otwórz",
    "emptyTitle": "Brak workspace’ów",
    "empty": "Ta organizacja nie ma jeszcze workspace’ów."
  },
  "loadError": "Nie udało się wczytać pulpitu.",
  "demo": {
    "toggle": "Zobacz potencjał dashboardu",
    "bannerTitle": "Oglądasz przykładowe dane",
    "bannerMessage": "Wymyślone, intensywne dwa tygodnie — tak wygląda ten dashboard, gdy Twoje zdjęcia, ekipa i callsheety są w Atellio. Linki są wyłączone.",
    "exit": "Wróć do moich danych"
  }
}
